
export function renderNetraaLHReleaseNotes1 () {
    return (
  <div>
    <main className="transition-opacity duration-300">
      <div className="py-4">

        {/* Header */}
        <div className="mb-10 scroll-m-24" id="release-details">
          <span className="inline-block px-3 py-1 mb-4 text-xs font-bold tracking-wider text-orange-600 uppercase bg-orange-100 rounded-full dark:bg-orange-900/30 dark:text-orange-400">
            Release Notes
          </span>

          <h1 className="text-3xl lg:text-4xl font-extrabold text-text-main dark:text-white tracking-tight mb-4">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
              Netraa LH Release Notes
            </span>
          </h1>

          <p className="text-lg text-text-muted dark:text-gray-400 leading-relaxed">
            Latest updates including feature enhancements, performance improvements, and bug fixes.
          </p>
        </div>

        {/* Confidentiality */}
        {/* <div className="bg-red-50 dark:bg-red-900/20 border-l-4 border-red-500 p-4 mb-10 rounded-r-lg">
          <h4 className="text-sm font-bold text-red-800 dark:text-red-300 mb-2">
            Confidentiality Statement
          </h4>
          <p className="text-xs text-red-700 dark:text-red-400 leading-relaxed whitespace-pre-line">
            The information contained in any Communication or Documentation distributed by ApMoSys, including attachments, is strictly confidential and intended solely for delivery to, and authorized use by, the identified addressee(s), as it may contain legally privileged and/or confidential information. If you are not the intended recipient of the Communication, you are hereby notified that any reading, disclosure, dissemination, distribution or copying of the Communication, and any attachments thereto, is strictly prohibited. If you have received the Communication in error, please notify the sender immediately and delete the message, and any copies and printouts thereof, from your records.
          </p>
        </div> */}
         {/* Release Info Table */}
        <section className="mb-12 scroll-m-24" id="">
          <h2 className="text-xl font-bold text-text-main dark:text-white mb-4">
            Release Details
          </h2>

          <div className="overflow-x-auto border border-border-color dark:border-border-dark rounded-xl">
            <table className="w-auto text-left border-collapse text-sm">
              <thead>
                <tr>
                  <th className="px-4 py-3 font-bold text-text-muted">Release Date</th>
                  <th className="px-4 py-3 font-bold text-text-muted">Release Type</th>
                  <th className="px-4 py-3 font-bold text-text-muted">Author Name</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="px-4 py-3 font-medium text-primary">16th April 2026</td>
                  <td className="px-4 py-3">Enhancements & Fixes</td>
                  <td className="px-4 py-3">Navodya Tyagi</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

      {/* Introduction */}
<section className="mb-12 scroll-mt-24" id="introduction">
  <div className="p-6 rounded-2xl bg-gradient-to-r from-orange-50 to-transparent dark:from-orange-900/20 dark:to-transparent border border-border-color dark:border-border-dark">
    
    <h2 className="text-2xl font-bold text-text-main dark:text-white mb-3">
      Introduction
    </h2>

    <p className="text-sm text-text-muted dark:text-gray-400 leading-relaxed">
      We are excited to announce the latest updates to our platform Netraa LH, packed with several feature enhancements, improvements, and bug fixes. This release aims to provide a better user experience, streamline processes, and increase overall efficiency.
    </p>

  </div>
</section>


{/* Release Summary */}
<section className="mb-16">
  <h2 className="text-2xl font-bold text-text-main dark:text-white mb-4">
    Release Summary
  </h2>

  <p className="text-sm text-text-muted dark:text-gray-400 mb-6">
    This release focuses on strengthening the control, transparency, and operational efficiency of the Netraa LH platform. The enhancements are centered around three core pillars:
  </p>

  {/* Pillars */}
  <div className="grid md:grid-cols-3 gap-5 mb-6">

    {[
      {
        title: "Governance",
        text: "Introducing stricter role-based access controls (RBAC) to ensure that critical actions are restricted to appropriate user levels",
        color: "orange"
      },
      {
        title: "Auditability",
        text: "Building a robust escalation logging mechanism with mandatory justifications and user traceability",
        color: "blue"
      },
      {
        title: "Usability & Reporting",
        text: "Enhancing dashboard visibility, structured workflows, and export capabilities for better decision-making",
        color: "green"
      }
    ].map((item, i) => (

      <div
        key={i}
        className="p-5 rounded-2xl border border-border-color dark:border-border-dark bg-surface-light dark:bg-surface-dark hover:shadow-md transition"
      >

        {/* Top Accent Line */}
        <div className={`h-1 w-10 mb-3 rounded-full 
          ${item.color === "orange" && "bg-orange-500"}
          ${item.color === "blue" && "bg-blue-500"}
          ${item.color === "green" && "bg-green-500"}
        `} />

        <h4 className="font-semibold text-text-main dark:text-white mb-2">
          {item.title}
        </h4>

        <p className="text-sm text-text-muted dark:text-gray-400 leading-relaxed">
          {item.text}
        </p>

      </div>

    ))}

  </div>

  <p className="text-sm text-text-muted dark:text-gray-400">
    Collectively, these improvements enable monitoring teams to operate with greater accountability, clarity, and efficiency, while empowering leadership with better visibility and control.
  </p>

</section>

  {/* Key Enhancements */}
  <section className="scroll-mt-24" id="enhancements">
    <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6">
      Key Enhancements
    </h2>

    <div className="space-y-5">

      {[
        {
          title: "Strengthened Role-Based Access Control (RBAC)",
          points: [
            "Escalation Button visible only to L2+ users",
            "On/Off Market Monitor filter restricted to L2+",
            "Client Name field visibility controlled via RBAC"
          ],
          desc: "Ensures clear separation of responsibilities and reduces operational inconsistencies."
        },
        {
          title: "Enhanced Live Dashboard Experience",
          points: [
            "Client Name field for grouping monitors",
            "Export Live Dashboard data for reporting"
          ],
          desc: "Improves usability for managerial and reporting purposes."
        },
        {
          title: "Structured & Controlled Escalation Workflow",
          points: [
            "Escalation start time",
            "Mandatory description (min 50 chars)",
            "Multi-instance selection",
            "Page name, exception type, error type",
            "Screenshot attachment"
          ],
          desc: "Ensures escalations are consistent, complete, and actionable."
        },
        {
          title: "Comprehensive Escalation Logging & Audit Trail",
          points: [
            "All escalation/de-escalation actions logged",
            "Tracks user actions",
            "Monitor-level log visibility",
            "Mandatory justification"
          ],
          desc: "Improves audit readiness and root cause analysis."
        },
        {
          title: "Escalation History Management (CRUD)",
          points: [
            "Create, View, Update, Delete records"
          ],
          desc: "Keeps escalation data accurate and maintainable."
        },
        {
          title: "Data Export & Historical Reporting",
          points: [
            "Includes instance, date, page name",
            "Start & End time tracking",
            "Descriptions, exception & error types",
            "Supports up to 3 months history"
          ],
          desc: "Enables trend analysis and reporting."
        }
      ].map((item, index) => (
        <div
          key={index}
          className="p-5 rounded-2xl border border-border-color dark:border-border-dark bg-surface-light dark:bg-surface-dark hover:shadow-sm transition"
        >
          <div className="flex gap-4">

            {/* Number */}
            <div className="w-9 h-9 flex items-center justify-center rounded-full bg-orange-100 dark:bg-orange-900/30 text-orange-600 text-sm font-bold flex-shrink-0">
              {index + 1}
            </div>

            <div>
              <h4 className="font-semibold text-text-main dark:text-white mb-2">
                {item.title}
              </h4>

              <ul className="list-disc pl-5 space-y-1 text-sm text-text-muted dark:text-gray-400 mb-2">
                {item.points.map((p, i) => (
                  <li key={i}>{p}</li>
                ))}
              </ul>

              <p className="text-sm text-text-muted dark:text-gray-400">
                {item.desc}
              </p>
            </div>

          </div>
        </div>
      ))}

    </div>
  </section>

  {/* Impact */}
 <section className="mb-16 mt-6">
  <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6">
    Impact & Business Value
  </h2>

  <div className="space-y-4">

    {[
      {
        title: "Improved Governance",
        desc: "Clear role demarcation reduces risk and enforces accountability"
      },
      {
        title: "Higher Data Quality",
        desc: "Mandatory inputs ensure better context and consistency in escalations"
      },
      {
        title: "Enhanced Transparency",
        desc: "Complete audit trails provide visibility into all actions"
      },
      {
        title: "Operational Efficiency",
        desc: "Structured workflows reduce ambiguity and manual overhead"
      },
      {
        title: "Stronger Reporting Capabilities",
        desc: "Export features enable deeper insights and stakeholder communication"
      }
    ].map((item, i) => (

      <div
        key={i}
        className="flex items-start gap-4 p-4 rounded-xl border border-border-color dark:border-border-dark bg-surface-light dark:bg-surface-dark hover:shadow-sm transition"
      >

        {/* Icon / Bullet */}
        <div className="w-9 h-9 flex items-center justify-center rounded-full bg-green-100 dark:bg-green-900/30 text-green-600 flex-shrink-0">
          ✓
        </div>

        {/* Content */}
        <div>
          <h4 className="font-semibold text-text-main dark:text-white">
            {item.title}
          </h4>
          <p className="text-sm text-text-muted dark:text-gray-400">
            {item.desc}
          </p>
        </div>

      </div>

    ))}

  </div>
</section>
      </div>
    </main>
  </div>
);
}